import { render, staticRenderFns } from "./SendSingleSignature.vue?vue&type=template&id=6b516877&scoped=true&"
import script from "./SendSingleSignature.vue?vue&type=script&lang=js&"
export * from "./SendSingleSignature.vue?vue&type=script&lang=js&"
import style0 from "./SendSingleSignature.vue?vue&type=style&index=0&id=6b516877&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b516877",
  null
  
)

export default component.exports